<template>
	<div class="container text-center py-5">
		<p class="text-muted mt-2 mb-0">{{ getModuleNumber() }}</p>
		<h1 class="">{{ moduleText('title') }}</h1>
		<p>{{ moduleText('description') }}</p>
		<hr>
		<!-- <b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon> -->

		<div v-if="fetchError">
			<hr>
			<p class="text-danger">{{ fetchErrorMessage }}</p>
		</div>

		<!-- Task list -->
		<div class="task-list">

			<!-- Loading icon -->
			<div v-if="tasks.length == 0" class="text-center p-5">
				<div class="spinner-border text-warning" style="width: 3rem; height: 3rem;" role="status"></div>
			</div>

			<!-- Progress bar -->
			<div class="progress progress-thin">
				<div class="progress-bar"></div>
			</div>
			<div
				v-for="chapter in chapters"
				:key="chapter[0]"
				class="progress"
				:style="{
					height: 100*(chapter.length-1)/(tasks.length-1) + '%',
					top: 100*chapter[0]/(tasks.length-1) + '%'
				}"
			>
				<div
					class="progress-bar progress-bar-striped progress-bar-animated bg-warning"
					:style="{ 'height': ((progressIndex-chapter[0]) / (chapter.length-1) * 100) + '%' }"
				></div>
			</div>

			<!-- Task -->
			<router-link
				v-for="(taskName, index) in tasks"
				:key="taskName"
				:is="(!$tracker.debug && !$tracker.skip && ((!isTaskComplete(taskName) && (index != progressIndex) && !isStartOfChapter(index)) || isBlocked(moduleName, taskName))) ? 'span' : 'router-link'"
				class="task no-select"
				:class="{
					'task-top': index == 0,
					'task-bottom': index == tasks.length-1,
					'task-incomplete': !isTaskComplete(taskName) && (index != progressIndex || isBlocked(moduleName, taskName)),
					'task-complete': isTaskComplete(taskName) && (index != progressIndex),
					'task-active': (index == progressIndex && !isBlocked(moduleName, taskName)),
					'task-separate': !getTaskNumber(taskName)
				}"
				:to="'/' + moduleName + '/' + taskName"
			>

				<!-- Dot -->
				<div class="progress-dot" :class="{ 'progress-dot-square': !getTaskNumber(taskName) }">
					<b-icon v-if="isBlocked(moduleName, taskName)" icon="lock-fill" class="h6 in-dot-icon opacity-50"></b-icon>
					<b-icon v-else-if="isTaskComplete(taskName)" icon="check" class="h5 in-dot-icon"></b-icon>
				</div>

				<!-- Name -->
				<div class="task-name">
					<small v-if="getTaskNumber(taskName)" class="me-3 my-0">{{ getTaskNumber(taskName) }}</small>
					<h5 class="my-0">{{ getTaskTitle(taskName) }}</h5>
					<small v-if="!getTaskNumber(taskName)" class="me-3 my-0" style="">{{ getTaskNumber(taskName) }}</small>
				</div>

				<!-- Chapter -->
				<small v-if="isStartOfChapter(index)" class="chapter-name">{{ getText('chapter') }} {{ index == 0 ? 1 : 2 }}</small>
			</router-link>

			<!-- Dummy element to set width -->
			<h5 class="dummy">{{ longestSentence }}</h5>
		</div>

		<!-- <div v-if="nextModule" class="d-flex my-3">
			<router-link
				class="btn m-auto px-5 py-2"
				style="border-radius: 100em; background-color: var(--bs-warning);"
				:to="nextModule">
				<span>{{ getText('continue') }}</span>
			</router-link>
		</div> -->
		<div class="d-flex my-3">
			<router-link
				class="btn m-auto px-5 py-2 text-muted"
				style="border-radius: 100em; background-color: var(--bs-gray-300);"
				:to="'/'">
				<span>{{ getText('back') }}</span>
			</router-link>
		</div>
	</div>
</template>



<script>
export default {
	props: [ "moduleName", "fromTaskName" ],
	data() {
		return {
			moduleId: this.routeToId(this.moduleName),
			nextModule: null,
			tasks: [],
			chapters: [],
			progressIndex: 0,
		};
	},

	mounted() {
		this.onSessionLoad();
	},

	methods: {
		onSessionLoad() {
			if (this.$tracker.modules.length > 0) {
				let data = this.$tracker.modules.find(m => m.name == this.moduleName);
				if (data) {
					this.tasks = data.tasks;

					this.chapters = [];
					let buffer = [];
					for (let i = 0; i < this.tasks.length; i++) {
						buffer.push(i);
						if (this.tasks[i].startsWith('quiz')) {
							this.chapters.push(buffer);
							buffer = [];
						}
					}

					this.updateProgress();
					this.redirectToNext();
				}
				else {
					console.error("Error in Module fetch:", this.fetchError);
					this.$router.replace({ name: 'Home' });
				}
			}
		},

		moduleText(key) {
			return this.$t(`${this.moduleId}_${key}`);
		},
		taskText(taskId, key) {
			return this.$t(`${taskId}_${key}`);
		},

		getModuleNumber() {
			return this.$t('module') + ' ' + this.routeToNumber(this.moduleName);
		},
		getTaskNumber(taskName) {
			if (taskName.startsWith('task')) {
				return this.$t('task') + ' ' + this.routeToNumber(taskName);
			}
			else {
				return null;
			}
		},
		getTaskTitle(taskName) {
			if (taskName.startsWith('task')) {
				return this.taskText(this.routeToId(this.moduleName, taskName), 'title');
			}
			else {
				return this.$t('quiz') + ' ' + this.routeToNumber(taskName);
			}
		},
		isStartOfChapter(index) {
			if (index == 0)
				return true;
			if (this.tasks[index-1].startsWith('quiz'))
				return true;
			return false;
		},
		isTaskComplete(taskName) {
			const taskId = this.routeToId(this.moduleName, taskName);
			return this.$tracker.isTaskComplete(taskId);
		},
		isModuleComplete() {
			if (this.tasks.length > 0) {
				return this.tasks.every(task => this.isTaskComplete(task));
			}
		},

		redirectToNext() {
			let currentIndex = this.tasks.indexOf(this.fromTaskName);

			if (currentIndex == -1) {
				return;
			}

			// Auto-navitate to next task
			if (currentIndex+1 < this.tasks.length) {
				// this.$router.push({
				// 	name: 'Task',
				// 	params: {
				// 		moduleName: this.moduleName,
				// 		taskName: this.tasks[currentIndex + 1]
				// 	}
				// });
				const taskName = this.tasks[currentIndex + 1];
				if (!this.isTaskComplete(taskName)) {
					this.$router.replace(`/${this.moduleName}/${taskName}`);
				}
			}
			// Module completed
			else {
				console.warn("Module completed");

				if (this.isModuleComplete()) {
					this.$router.replace(`/`);

					// Find next module
					// let index = this.$tracker.modules.findIndex(m => m.name == this.moduleName);
					// if (index < this.$tracker.modules.length) {
					// 	let mod = this.$tracker.modules[index+1];
					// 	let taskName = mod.tasks[0];
					// 	let taskId = this.routeToId(mod.name, taskName);
					// 	if (!this.$tracker.isTaskComplete(taskId)) {
					// 		this.$router.replace(`/${mod.name}/${taskName}`);
					// 	}
					// }
				}
			}

		},

		updateProgress() {
			if (this.tasks && this.$tracker.session) {
				this.progressIndex = 0;
				for (const taskName of this.tasks) {
					if (this.isTaskComplete(taskName))
						this.progressIndex++;
					else
						break;
				}

				this.$forceUpdate();

				this.nextModule = null;
				let index = this.$tracker.modules.findIndex(m => m.name == this.moduleName);
				if (this.isModuleComplete() && index < this.$tracker.modules.length) {
					this.nextModule = "/" + this.$tracker.modules[index+1].name;
				}
			}
		},

		isBlocked(moduleName, taskName) {
			// if (moduleName == 'module-2' && ['task-4a', 'task-4b', 'task-5', 'task-6a', 'task-6b', 'quiz-2'].includes(taskName)) {
			// 	return true;
			// }
			// if (moduleName == 'module-3') {
			// 	return true;
			// }
			return false && moduleName == taskName;
		}
	},

	computed: {
		longestSentence() {
			let names = this.tasks.map(taskName => this.getTaskTitle(taskName));
			if (names.length > 0) {
				return names.reduce(
					(a, b) => {
						return a.length > b.length ? a : b;
					}
				);
			}
			else {
				return "";
			}
		}
	},
};
</script>



<style scoped>
	.task-list {
		/*display: flex;*/
		display: inline-block;
		/*padding: 3em;*/
		/*overflow: hidden;*/
		/*max-width: 500px;*/
		flex-basis: auto;
		text-align: left;
		position: relative;
		flex-direction: column;

		/*margin: 3em 3em;*/
		margin: 3em auto;
	}


	.task {
		display: flex;
		position: relative;
		margin: 0 0.26em;
		padding: 1.1rem 0.2rem;
		transition: all 0.1s ease;
		cursor: pointer;
		text-decoration: none;
	}
	.task-top { margin-top: -1.6em; }
	.task-bottom { margin-bottom: -1.6em; }
	.task:hover {
		padding-left: calc(0.2rem + 0.3rem);
	}

	.task-name {
		height: 2.5em;
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-left: 1.7rem;
	}


	.task-incomplete {
		color: var(--bs-gray-300);
	}
	.task-complete {
		color: var(--bs-gray-600);
	}
	.task-active {
		color: var(--bs-gray-900);
		padding-left: 0.8rem;
	}
	.task-active.task:hover {
		padding-left: calc(0.8rem + 0.3rem);
	}

	.task-incomplete:hover {
		background-color: var(--bs-gray-200);
		color: var(--bs-gray-600);
	}
	.task-complete:hover {
		background-color: var(--bs-warning);
		/*background-color: #ffc10733;*/
		color: var(--bs-gray-800);
	}
	.task-active:hover {
		/*background-color: #ffc10733;*/
		background-color: var(--bs-warning);
	}

	.task-separate {
		/*margin-bottom: 1em;*/
	}


	.progress {
		/*z-index: 1;*/
		position: absolute;
		/*left: 50.5%;*/
		/*top: 40%;*/
		transform: translateX(-50%);
		width: 0.75em;
		height: 100%;
		/*background-color: #4f617816;*/
	}
	.progress-thin {
		/*width: 3px !important;*/
		opacity: 0;
	}
	.progress-bar {
		position: absolute;
		top: 0%;
		width: 100%;
		transition: all 0.5s ease;
	}

	.progress-dot {
		/*z-index: 2;*/
		position: absolute;
		width: 2em;
		height: 2em;
		left: -0.26em;
		top: 50%;
		transform: translate(-50%, -50%);
		background-color: var(--bs-warning);
		border: 4px solid var(--bs-light);
		border-radius: 100%;

		text-align: center;
		font-weight: bold;
		/*line-height: calc(28px);*/
		color: black;
		color: var(--bs-dark);

		transition: all 0.1s ease;
	}
	.progress-dot-square {
		border-radius: 0.5em;
	}
	.in-dot-icon {
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.task-incomplete .progress-dot {
		background-color: #ccc;
		border-color: var(--bs-light);
		/*color: rgba(0, 0, 0, 0.6);*/
	}
	.task-complete .progress-dot {
		background-color: var(--bs-warning);
		border-color: var(--bs-light);
		/*color: rgba(0, 0, 0, 0.6);*/
	}
	.task-active .progress-dot {
		background-color: var(--bs-light);
		border-color: var(--bs-warning);
		width: calc(2em + 0.3em);
		height: calc(2em + 0.3em);
	}

	.task:hover .progress-dot {
		width: calc(2em + 0.3em);
		height: calc(2em + 0.3em);
	}
	.task-active.task:hover .progress-dot {
		width: calc(2em + 0.3em + 0.4em);
		height: calc(2em + 0.3em + 0.4em);
	}


	.chapter-name {
		position: absolute;
		text-align: right;
		width: 20em;
		right: 100%;
		top: 50%;
		padding-right: 3em;
		transform: translateY(-50%);
		opacity: 0.5;
	}
	.task-incomplete .chapter-name {
		opacity: 1.0;
	}

	.dummy {
		margin: 0 0 0 5rem;
		opacity: 0;
		height: 0;
		pointer-events: none;
	}
</style>
